import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.001 16.047" width="1em" height="1em" {...props}><g color="#000" fontWeight={400} fill="#2e3436"><path d="M9.003.09v2.04a4.98 4.98 0 013.566 2.888h-1.568c-.554 0-1 .446-1 1v1h6v-6h-1c-.554 0-1 .446-1 1v1.396A7.037 7.037 0 009.003.09zm0 12.781v.3a1 1 0 000-.3z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1
      }} fontFamily="sans-serif" overflow="visible" fillRule="evenodd" /><path d="M9.74 16.047c.515 0 1.021-.177 1.407-.562l4.25-4.25c.77-.772.756-2.074 0-2.844l-.472-.373H12.08l1.91 1.81-4.25 4.22-7.72-7.782c-.015-.016-.043-.02-.03-.031l4.25-4.25 1.735 1.899V1.07L7.678.61 7.647.578a1.999 1.999 0 00-2.813 0l-4.25 4.25a2.004 2.004 0 000 2.813l7.75 7.844c.386.388.892.563 1.407.562z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} fontFamily="Sans" overflow="visible" /></g></svg>;
}

export default SvgComponent;